import React from 'react';
import PropTypes from 'prop-types';

import isNaN from 'lodash/isNaN';

import { NumberInput } from 'uikit/inputs';

const FormFieldNumber = ({
  fieldId,
  schema = {
    isDisabled: false,
    isFullWidth: false,
    label: '',
    maxValue: null,
    minValue: null,
    prefixInputLabel: '',
    shouldPreventScrollableChanges: false,
  },
  updateField,
  value = '',
}) => {
  const transformedValue = value === null || isNaN(value) ? '' : value;

  return (
    <NumberInput
      id={fieldId}
      value={transformedValue}
      onChange={(inputValue) => updateField(isNaN(inputValue) ? null : inputValue)}
      label={schema.prefixInputLabel || schema.label}
      minValue={schema.minValue}
      maxValue={schema.maxValue}
      isDisabled={schema.isDisabled}
      shouldPreventScrollableChanges={schema.shouldPreventScrollableChanges}
    />
  );
};

FormFieldNumber.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  schema: PropTypes.shape({
    label: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    isDisabled: PropTypes.bool,
    prefixInputLabel: PropTypes.string,
    shouldPreventScrollableChanges: PropTypes.bool,
  }),
  updateField: PropTypes.func.isRequired,
};

export default FormFieldNumber;
